"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const Label_1 = __importDefault(require("../../elements/Label"));
const FormikColumnFormatField_1 = require("../../elements/formik/FormikColumnFormatField");
const FormikInput_1 = __importDefault(require("../../elements/formik/FormikInput"));
const useNucleus_1 = __importDefault(require("../../hooks/useNucleus"));
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const getUniqueNuclei_1 = require("../../utility/getUniqueNuclei");
const NucleusPreferences_1 = require("../extra/preferences/NucleusPreferences");
const PreferencesContainer_1 = require("../extra/preferences/PreferencesContainer");
const formatFields = [
    {
        id: 1,
        label: 'Serial number :',
        checkControllerName: 'showSerialNumber',
        hideFormatField: true,
    },
    {
        id: 2,
        label: 'From (ppm) :',
        checkControllerName: 'from.show',
        formatControllerName: 'from.format',
    },
    {
        id: 3,
        label: 'To (ppm) :',
        checkControllerName: 'to.show',
        formatControllerName: 'to.format',
    },
    {
        id: 4,
        label: 'Absolute integration :',
        checkControllerName: 'absolute.show',
        formatControllerName: 'absolute.format',
    },
    {
        id: 5,
        label: 'Relative integration :',
        checkControllerName: 'relative.show',
        formatControllerName: 'relative.format',
    },
    {
        id: 6,
        label: 'δ (ppm) :',
        checkControllerName: 'deltaPPM.show',
        formatControllerName: 'deltaPPM.format',
    },
    {
        id: 7,
        label: 'δ (Hz) :',
        checkControllerName: 'deltaHz.show',
        formatControllerName: 'deltaHz.format',
    },
    {
        id: 8,
        label: 'Coupling (Hz) :',
        checkControllerName: 'coupling.show',
        formatControllerName: 'coupling.format',
    },
    {
        id: 9,
        label: 'Kind :',
        checkControllerName: 'showKind',
        hideFormatField: true,
    },
    {
        id: 10,
        label: 'Multiplicity :',
        checkControllerName: 'showMultiplicity',
        hideFormatField: true,
    },
    {
        id: 11,
        label: 'Assignment :',
        checkControllerName: 'showAssignment',
        hideFormatField: true,
    },
    {
        id: 12,
        label: 'Delete action :',
        checkControllerName: 'showDeleteAction',
        hideFormatField: true,
    },
    {
        id: 13,
        label: 'Zoom action :',
        checkControllerName: 'showZoomAction',
        hideFormatField: true,
    },
    {
        id: 14,
        label: 'Edit action :',
        checkControllerName: 'showEditAction',
        hideFormatField: true,
    },
];
function RangesPreferences(props, ref) {
    const formRef = (0, react_1.useRef)();
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const nucleus = (0, useNucleus_1.default)();
    const nuclei = (0, react_1.useMemo)(() => (0, getUniqueNuclei_1.getUniqueNuclei)(nucleus), [nucleus]);
    const preferencesByNuclei = (0, usePanelPreferences_1.usePanelPreferencesByNuclei)('ranges', nuclei);
    function saveHandler(values) {
        preferences.dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'ranges', value: values },
        });
    }
    (0, react_1.useImperativeHandle)(ref, () => ({
        saveSetting: () => {
            formRef.current.submitForm();
        },
    }), []);
    return ((0, jsx_runtime_1.jsx)(PreferencesContainer_1.PreferencesContainer, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: preferencesByNuclei, enableReinitialize: true, onSubmit: saveHandler, innerRef: formRef, children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: nuclei?.map((n) => ((0, jsx_runtime_1.jsx)(NucleusPreferences_1.NucleusPreferences, { nucleus: n, fields: formatFields, renderBottom: () => ((0, jsx_runtime_1.jsx)(Label_1.default, { title: "J Graph tolerance (Hz) :", style: FormikColumnFormatField_1.formatFieldLabelStyle, children: (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex' }, children: [(0, jsx_runtime_1.jsx)("div", { style: { width: '23px' } }), (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: `nuclei.${n}.jGraphTolerance`, type: "number", style: FormikColumnFormatField_1.formatFieldInputStyle })] }) })) }, n))) }) }) }));
}
exports.default = (0, react_1.forwardRef)(RangesPreferences);
